import { StarterDashboardV2TabsStateContextProvider } from './context';
import { useTabsState } from './hook';

export function StarterDashboardV2TabsStateProvider({ children }: { children: React.ReactNode }): JSX.Element {
	const tabsState = useTabsState();

	return (
		<StarterDashboardV2TabsStateContextProvider value={tabsState}>
			{children}
		</StarterDashboardV2TabsStateContextProvider>
	);
}
